<div class="attributes-section w-full bg-neutral-50 p-4 rounded-lg">
  @if (isCollapsable()) {
    <flx-accordion>
      <flx-accordion-item [opened]="!isCollapsed()">
        <ng-container flxAccordionItemTitle>
          <span> {{ header() }}</span>
        </ng-container>

        <ng-template [ngTemplateOutlet]="tableTemplate"></ng-template>
      </flx-accordion-item>
    </flx-accordion>
  } @else {
    <div class="text-sm pb-4 font-semibold">{{ header() }}</div>
    <ng-template [ngTemplateOutlet]="tableTemplate"></ng-template>
  }
</div>

<ng-template #tableTemplate>
  <table class="table-fixed w-full">
    <thead>
      <tr>
        @for (type of columns; track type.field) {
          <th
            [style.width]="type.width ?? 'auto'"
            class="text-left text-neutral-400 text-xs font-normal pb-2"
          >
            {{ type.header }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (reference of uiReferences(); track reference) {
        <tr
          [attr.data-testid]="`attribute-reference-row-${reference.nodeDefinitionName}-${reference.entityType}`"
        >
          <td class="text-left py-2 w-3/10">{{ reference.type }}</td>
          <td class="text-left py-2 w-6/10">
            <div
              [pTooltip]="getContextLabels(reference.context)"
              class="flex flex-row items-center gap-x-2 truncate"
              tooltipPosition="bottom"
            >
              @for (context of reference.context; track $index) {
                <div class="flex flex-row items-center gap-x-1">
                  @if (context.icon) {
                    <flx-icon
                      [name]="context.icon"
                      [attr.data-testid]="`context-icon-${reference.nodeDefinitionName}-${reference.entityType}`"
                      class="w-3 h-3 stroke-neutral-500"
                    />
                  }
                  <span class="capitalize"> {{ context.label }}</span>
                </div>
                @if (!$last) {
                  <span> \ </span>
                }
              }
            </div>
          </td>

          <td class="text-center py-2 w-1/10">
            <button
              [attr.data-testid]="`goto-reference-link-${reference.nodeDefinitionName}-${reference.entityType}`"
              (click)="goToReference(reference)"
              class="flex justify-center"
              clickStopPropagation
            >
              <flx-icon
                [attr.data-testid]="`goto-reference-icon-${reference.nodeDefinitionName}-${reference.entityType}`"
                name="arrow-right-circle"
                class="text-neutral-500 hover:text-blue-500 cursor-pointer"
                pTooltip="Go to reference"
                tooltipPosition="bottom"
              ></flx-icon>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>
